export function getChangeInfo(e) {
    const change = {
        what_to_change: '',
        info: {}

    }
    if (e.colDef.field === 'name' || e.colDef.field === 'code') {
        alert('Редактировать товар можно только в разделе "товары"')
        return false
    }
    let difference = 0
    if (typeof e.oldValue === 'number' && e.oldValue !== 0) {
        difference = Math.abs(e.newValue - e.oldValue) / e.oldValue;
    }
    if (e.colDef.field === 'min_price') {
        change.what_to_change = 'min_price'
        change.info = {
            data: {
                'code': e.data.context.code,
                'min_price': e.newValue,
            },
            product_id: e.data.id,
            difference: difference
        }
        return change
    }
    if (e.colDef.field === 'cost') {
        change.what_to_change = 'cost'
        change.info = {
            data: {
                'code': e.data.context.code,
                'cost': e.newValue
            },
            product_id: e.data.id,
            'difference': difference
        }
        return change
    }
    if (e.colDef.field.includes('_profit_amount')) {
        const store_id = e.colDef.field.replace('_profit_amount', '')
        const offer_id = e.data[store_id].offer_id
        change.what_to_change = 'profit'
        change.info = {
            'offer_id': offer_id,
            'profit_amount': e.newValue,
            'difference': difference,
            'info__marketplace': e.colDef.context.marketplace,
            'info__is_in_actions': e.data[store_id].store_info.is_in_actions
        }
        return change
    }
    if (e.colDef.field.includes('_old_price')) {
        const store_id = e.colDef.field.replace('_old_price', '')
        const offer_id = e.data[store_id].offer_id
        change.what_to_change = 'ozon_old_price'
        change.info = {
            'offer_id': offer_id,
            'old_price': e.newValue,
            'product_id': e.data.id,
            'info__marketplace': e.colDef.context.marketplace
        }
        return change
    }
    if (e.colDef.field.includes('_price')) {
        const store_id = e.colDef.field.replace('_price', '')
        const offer_id = e.data[store_id].offer_id
        change.what_to_change = 'price'
        change.info = {
            'offer_id': offer_id,
            'price': e.newValue,
            'difference': difference,
            'info__marketplace': e.colDef.context.marketplace,
            'info__is_in_actions': e.data[store_id].store_info.is_in_actions,
            'info__old_price': e.data[store_id].store_info?.old_price
        }
        return change
    }
    if (e.colDef.field.includes('_profit_percent_cost')) {
        const store_id = e.colDef.field.replace('_profit_percent_cost', '')
        const offer_id = e.data[store_id].offer_id
        change.what_to_change = 'profit_percent_cost'
        change.info = {
            'offer_id': offer_id,
            'profit_percent_cost': e.newValue,
            'difference': difference,
            'info__marketplace': e.colDef.context.marketplace,
            'info__is_in_actions': e.data[store_id].store_info.is_in_actions
        }
        return change
    }
    if (e.colDef.field.includes('_profit_percent')) {
        const store_id = e.colDef.field.replace('_profit_percent', '')
        const offer_id = e.data[store_id].offer_id
        change.what_to_change = 'profit_percent'
        change.info = {
            'offer_id': offer_id,
            'profit_percent': e.newValue,
            'difference': difference,
            'info__marketplace': e.colDef.context.marketplace,
            'info__is_in_actions': e.data[store_id].store_info.is_in_actions
        }
        return change
    }
    return change
}

export function isEditable(cell) {
    if (cell.data.in_process) {
        return false
    }
    return true
}

function isElementTruncated(el) {
    if (!el) return false
    if (el.scrollWidth > el.clientWidth + 1) {
        return true
    }

    const range = document.createRange()
    range.selectNodeContents(el)
    const textWidth = range.getBoundingClientRect().width
    const style = window.getComputedStyle(el)
    const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
    return textWidth > el.clientWidth - padding + 1
}

export function getTruncatedCellTooltip(params) {
    const value = params?.value
    if (value == null || value === '') {
        return undefined
    }

    const rowId = params.node?.id
    const colId = params.column?.getColId?.() || params.colDef?.field
    if (rowId == null || !colId) {
        return value
    }

    const rowSelector = `.ag-row[row-id="${CSS.escape(String(rowId))}"]`
    const cellSelector = `.ag-cell[col-id="${CSS.escape(String(colId))}"]`
    const cellEl = document.querySelector(`${rowSelector} ${cellSelector}`)
    if (!cellEl) {
        return value
    }

    const measureEls = [
        cellEl.querySelector('.ag-cell-value'),
        cellEl.querySelector('.ag-cell-wrapper'),
        cellEl
    ].filter(Boolean)

    return measureEls.some(isElementTruncated) ? value : undefined
}

export function needChangeOldPrice(price, oldPrice) {
    if (oldPrice == null) {
        return false
    }

    const currentPrice = Number(price)
    const currentOldPrice = Number(oldPrice)
    if (!Number.isFinite(currentPrice) || !Number.isFinite(currentOldPrice) || currentOldPrice === 0) {
        return false
    }

    if (currentOldPrice <= currentPrice) {
        return true
    }

    const difference = currentOldPrice - currentPrice
    if (difference / currentOldPrice >= 0.9) {
        return true
    }
    if (currentPrice <= 400) {
        return difference <= 20
    }
    if (currentPrice <= 10000) {
        return difference <= currentPrice * 0.05
    }
    return difference <= 500
}